export default function Header() {
  return (
    <header>
      <div className="container mx-auto px-6 sm:px-0"></div>
    </header>
  );
}